import { ISVG } from "./UrlIcon";

export const AddPadingIcon = ({ className }: ISVG) => (
    <svg
        width={21}
        height={20}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`group-hover:fill-white ${className}`}
    >
        <path d="M5.213 9.282a.882.882 0 0 1 0 1.436l-3.318 2.37A.882.882 0 0 1 .5 12.37V7.63a.882.882 0 0 1 1.395-.718l3.318 2.37Zm-3.537-1.08v3.596L4.194 10 1.676 8.202ZM20.5 7.63v4.74a.882.882 0 0 1-1.395.718l-3.318-2.37a.882.882 0 0 1 0-1.436l3.318-2.37a.882.882 0 0 1 1.395.718ZM16.806 10l2.517 1.798V8.202L16.806 10Zm-.424-5.294V.588a.588.588 0 0 1 1.177 0v4.706a.588.588 0 0 1-.588.588H4.029a.588.588 0 0 1-.588-.588V.588a.588.588 0 1 1 1.177 0v4.118h11.764ZM4.618 19.412a.588.588 0 1 1-1.177 0v-4.706c0-.325.264-.588.588-.588h12.942c.324 0 .588.263.588.588v4.706a.588.588 0 1 1-1.177 0v-4.118H4.618v4.118Z" />
    </svg>
);
